import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { ApplicationInsights, IEventTelemetry } from '@microsoft/applicationinsights-web';
import { Subscription } from 'rxjs';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApplicationInsightsService {
  private routerSubscription: Subscription;
  // private appInsights = new ApplicationInsights({
  //   instrumentationKey: 'a8aca698-844c-4515-9875-fb6b480e4fec'
  // });

  // private appInsights = new ApplicationInsights({ config: {
  //     instrumentationKey: environment.applicationInsightsInstrumentationKey
  //   }});

  private appInsights = null;
  constructor(private router: Router) {
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: environment.applicationInsightsInstrumentationKey
      }
    });
    this.appInsights.loadAppInsights();
    // if (this.router && this.router.events) {
    //   this.routerSubscription = this.router.events.pipe(filter(event => event instanceof ResolveEnd)).subscribe((event: ResolveEnd) => {
    //     const urlTree = this.router.parseUrl(this.router.url);
    //     console.log(this.router.getCurrentNavigation())
    //     console.log(urlTree);
    //     const urlWithoutParams = urlTree.root.children['primary'].segments.map(it => it.path).join('/');
    //     // const activatedComponent = this.getActivatedComponent(event.state.root);
    //     // if (activatedComponent) {
    //     //   this.logPageView(event.state.url.substring(0, 500));
    //     // }
    //   });
    // }
  }

  setUserId(userId: string) {
    this.appInsights.setAuthenticatedUserContext(userId);
  }
  setEmail(email: string) {
    this.appInsights.context.user.id = email;
  }
  setUserInfo(email: string, id: string, session_state: string) {
    this.appInsights.context.user.id = email;
    this.appInsights.context.session.id = session_state.slice(0, 63);
    this.appInsights.setAuthenticatedUserContext(id);
  }
  clearUserId() {
    this.appInsights.context.user.id = '';
    this.appInsights.clearAuthenticatedUserContext();
  }

  logPageView(name?: string, uri?: string) {
    this.appInsights.trackPageView({ name, uri });
  }

  trackEvent(eventName: string, customProperties: object) {
    this.appInsights.trackEvent({ name: eventName, customProperties } as IEventTelemetry);
  }
  trackException(exception: Error) {
    this.appInsights.trackException({ exception: exception });
  }

  private getActivatedComponent(snapshot: ActivatedRouteSnapshot): any {
    if (snapshot.firstChild) {
      return this.getActivatedComponent(snapshot.firstChild);
    }

    return snapshot.component;
  }

  private getRouteTemplate(snapshot: ActivatedRouteSnapshot): string {
    let path = '/';
    if (snapshot.routeConfig) {
      path = snapshot.routeConfig.path;
    }

    if (snapshot.firstChild) {
      return this.getRouteTemplate(snapshot.firstChild);
    }

    return path;
  }


}
